import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './Auth.css';

// Shown publicly, so it must match what the owner is happy to publish. Keep it in step with
// the MAIL_OWNER_NAME / MAIL_ADDRESS / MAIL_PHONE values used in the emails.
const OWNER = {
  name: 'Gopalareddy V',
  address: 'No.36/30/1, Kachanayakanahalli, Near milk diary, Hennagara post, Anekal taluk, Bangalore-560099',
  phone: '+91 9964656247',
};

const wrap = { width: '100%', maxWidth: 760, margin: '0 auto', color: 'var(--ink)' };
const card = { background: 'var(--surface)', borderRadius: 18, boxShadow: '0 18px 48px rgba(62,42,29,0.10)', border: '1px solid var(--line)', padding: '28px 26px', marginBottom: 20 };
const h2 = { fontSize: 18, margin: '0 0 10px', color: 'var(--ink)' };
const primaryBtn = {
  padding: '14px 28px', border: 'none', borderRadius: 8, fontWeight: 'bold', fontSize: 16, cursor: 'pointer',
  background: 'var(--grad-primary)', color: '#fff',
};
const secondaryBtn = { ...primaryBtn, background: 'var(--grad-success)' };

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const steps = ['step1', 'step2', 'step3'];

  return (
    <div className="auth auth--home">
    <div style={wrap}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
        <LanguageSwitcher />
      </div>

      <div style={{ ...card, textAlign: 'center' }}>
        <img src="/vgr-logo.png" alt="VGR" width="160" style={{ maxWidth: '60%', height: 'auto', borderRadius: 12 }} />
        <h1 style={{ fontSize: 28, margin: '14px 0 6px', color: 'var(--primary)' }}>{t('home.title')}</h1>
        <p style={{ margin: '0 0 8px', fontWeight: 600, color: 'var(--ink-soft)' }}>{t('home.tagline')}</p>
        <p style={{ margin: '0 auto 22px', maxWidth: 520, lineHeight: 1.55, color: 'var(--ink-soft)' }}>{t('home.intro')}</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button style={primaryBtn} onClick={() => navigate('/login')}>{t('login.login')}</button>
          <button style={secondaryBtn} onClick={() => navigate('/register')}>{t('home.registerFirst')}</button>
        </div>
      </div>

      <div style={card}>
        <h2 style={h2}>{t('home.howTitle')}</h2>
        <ol style={{ margin: 0, paddingLeft: 22, lineHeight: 1.7 }}>
          {steps.map((s) => <li key={s}>{t(`home.${s}`)}</li>)}
        </ol>
      </div>

      <div style={card}>
        <h2 style={h2}>{t('home.contactTitle')}</h2>
        <div style={{ lineHeight: 1.7 }}>
          <div><strong>{t('home.owner')}:</strong> {OWNER.name}</div>
          <div><strong>{t('home.address')}:</strong> {OWNER.address}</div>
          <div><strong>{t('home.phone')}:</strong> <a href={`tel:${OWNER.phone.replace(/\s/g, '')}`} style={{ color: 'var(--primary)' }}>{OWNER.phone}</a></div>
        </div>
      </div>

      <div style={{ fontSize: 13, textAlign: 'center', color: 'var(--muted)' }}>
        <Link to="/terms" style={{ color: 'var(--primary)', margin: '0 8px' }}>{t('home.terms')}</Link>
        <Link to="/refund-policy" style={{ color: 'var(--primary)', margin: '0 8px' }}>{t('home.refund')}</Link>
        <Link to="/privacy" style={{ color: 'var(--primary)', margin: '0 8px' }}>{t('home.privacy')}</Link>
      </div>
    </div>
    </div>
  );
}
